import React, { useEffect, useState, useCallback } from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { getCountryMessage } from "../../../../../api";
import Cache from "../../../../../utils/cache";
import { useDispatch, useSelector } from "react-redux";
import { TOGGLE_UI_LOGIN } from "../../../../../store/actions/ui";
import ReactDOM from 'react-dom'
import { Iconfont } from "../../../../components/icon/iconfont";
import { useQuery } from "../../../../hooks/common";
import { BlackMask } from "../../../../components/mask";
import { SET_SHOW_BOTTOM_BANNER } from "../../../../../store/actions/global";


const BottomStyle1 = props =>{
    const { bottomBanner, isFixed } = props;
    const [showBanner, setShowBanner] = useState(true);
    const dispatch = useDispatch();
    const global = useSelector(state=>state.global);

    useEffect(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELExpose', {
                clicks:"bottom-coupon",
            })
        }
    }, []);

    const handleCloseBanner = useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
        setShowBanner(false)
        Cache.set('bottom-banner', 1)

        dispatch({
            type: SET_SHOW_BOTTOM_BANNER,
            payload: false
        });

        // 清除大弹窗关闭缓存记录
        Cache.remove('promark-bigclose', 24*60*60*365);

        if(window.GeekoSensors){
            window.GeekoSensors.Track('CloseCoupon', {
                clicks:"bottom-coupon",
            })
        }
    }, []);

    const handleBottomClick = useCallback((e, b) => {
        e.preventDefault();
        e.stopPropagation();
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"bottom-coupon",
            })
        }

        if(b.isLogin){
            dispatch({
                type: TOGGLE_UI_LOGIN,
                payload: {
                    showLogin:true,
                    eventType:"弹窗",
                    callBack: function(){
                        // return dispatch(action_fetch_bottom_banner())
                        setShowBanner(false);
                    }
                }
            })
        }else if(b.href){
            window.location.href = b.href
        }
    }, [])

    const handleClick = () =>{
        // setType(2);
    }

    return <React.Fragment>
        {
            bottomBanner && bottomBanner?.title && showBanner && !global.user?.id && <React.Fragment>
                <div className={`${isFixed?classes.FixedBottomBanner:''}`}>
                    <div className={classes.BottomBanner} style={{
                        color: bottomBanner?.theme?.color,
                        background: bottomBanner?.theme?.background
                    }} onClick={handleClick}>
                        <Iconfont className={classes.Close} onClick={handleCloseBanner}>&#xe69a;</Iconfont>
                        <div className={classes.Content}>
                            <div className={classes.Title}>{bottomBanner?.title}</div>
                            <div className={classes.Description}>{global.user?.id && bottomBanner?.logedDescription ? bottomBanner?.logedDescription: bottomBanner?.description}</div>
                        </div>
                        {
                            bottomBanner?.button && ( !bottomBanner?.button.isLogin || (bottomBanner?.button.isLogin && !global.user?.id)) && <button onClick={(e) => handleBottomClick(e, bottomBanner?.button)} className={classes.Button} style={{color: bottomBanner?.button?.color ,backgroundColor: bottomBanner?.button?.backgroundColor}}>{bottomBanner?.button?.text}</button>
                        }
                    </div>
                </div>

                {
                    isFixed && <div className={classes.BottomBanner}></div>
                }
            </React.Fragment>
        }
    </React.Fragment>
}

const AlertDiscount = props =>{
    const { message, onClose, setType } = props;
    const { backgroundImage } = message;
    const dispatch = useDispatch();

    const handleClose = () =>{
        Cache.set('promark-bigclose', 1)
        dispatch({
            type: SET_SHOW_BOTTOM_BANNER,
            payload: false
        });
        
        setType(1);

        // onClose();

        if(window.GeekoSensors){
            window.GeekoSensors.Track('CloseCoupon', {
                clicks:"middle-coupon-1",
            })
        }
    }

    const handleBottomClick = useCallback((e, b) => {
        e.preventDefault();
        e.stopPropagation();
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"middle-coupon",
            })
        }

        if(b.isLogin){
            dispatch({
                type: TOGGLE_UI_LOGIN,
                payload: {
                    showLogin:true,
                    eventType:"弹窗",
                    callBack: function(){
                        // return dispatch(action_fetch_bottom_banner())
                        onClose();
                    }
                }
            })
        }else if(b.href){
            window.location.href = b.href
        }
    }, [])

    return <React.Fragment>
        <div className={classes.IndexAlert}>
            <a href={message?.href} onClick={(e)=>handleBottomClick(e, message)}><img src={backgroundImage?.url} /></a>
            
            <span className={classes.CloseContainer} onClick={handleClose}>
                <Iconfont className={classes.Close} >&#xe7c9;</Iconfont>
            </span>
        </div>

        <BlackMask onClick={handleClose} />
    </React.Fragment>
    
}

const BottomStyle2 = props =>{
    const [showAlert, setShowAlert] = useState(true);

    useEffect(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELExpose', {
                clicks:"middle-coupon",
            })
        }
    }, []);

    return <React.Fragment>
        {
            showAlert && ReactDOM.createPortal(
                <React.Fragment>
                    <AlertDiscount onClose={()=>setShowAlert(false)} {...props} />
                </React.Fragment>,
                typeof document !== 'undefined' ? document.getElementById('root') : null
            )
        }
    </React.Fragment>
    
}

const BottomBannerTip = props =>{
    useStyles(classes);
    const { isFixed } = props;
    const [data, setData] = useState(null);
    const query = useQuery();
    const [type, setType] = useState(1);
    const global = useSelector(state=>state.global);
    const dispatch = useDispatch();

    useEffect(async () =>{
        // if(query.utm_source && query.utm_source != "traffic"){
        //     Cache.remove('has-utmsource');
        // }

        const shouldShow = !!!Cache.get('bottom-banner');
        const canShowBottom = !!Cache.get('has-utmsource')

        // if(((query?.utm_source == "traffic") || canShowBottom) && shouldShow && !global?.user?.id){
        if(shouldShow && !global?.user?.id){    
            let response = await getCountryMessage("M1817");
            if(response?.code === 200 && response?.result){
                setData(response.result);
                const bigModalCloseFlag = !!Cache.get('promark-bigclose');
                const styletype = bigModalCloseFlag ? 1 : 2;
                setType(styletype);

                dispatch({
                    type: SET_SHOW_BOTTOM_BANNER,
                    payload: true
                });
            }

            // 作为utm_source来过的标记
            // Cache.set('has-utmsource', true, 24*60*60*365);
        }
    }, []);

    return <React.Fragment>
        {
            !!data && <React.Fragment>
                {
                    type === 1 && !!data?.style1 && <BottomStyle1 bottomBanner={data.style1} isFixed={isFixed} setType={setType} />
                }
                
                {
                    type === 2 && !!data?.style2 && <BottomStyle2 message={data.style2} setType={setType} />
                }
            </React.Fragment>
        }
    </React.Fragment>
}

export default BottomBannerTip;